import about01 from "../assets/about01.png";
import about04 from "../assets/about04.png";
import fleetfinesse from "../assets/fleetfinesse.webp"
import demoautomation from "../assets/demoautomation.png"
import docs from "../assets/docs.png"
import pakcarbazar from "../assets/pakcarbazar.png"
import images from "../assets/images.png"
import library from "../assets/library.png"
import cpp from "../assets/cpp.png"
import mongopng from "../assets/mongopng.jpeg"
import docker from "../assets/docker.webp"
import github from "../assets/github.png"
import aws from "../assets/aws.png"

export const data = [
    {
        title: "Front-end Developer",
        description: "Experienced in building responsive and optimized web applications using React and Angular.",
        imgUrl: about01
    },
    {
        title: "Backend Developer",
        description: "Experienced in developing scalable and efficient server-side applications using Node.js.",
        imgUrl: about04
    }
];



export const WorksData = [
    {
        title: "Fleet Finesse",
        description: "A powerful SaaS-based rental management solution with real-time control over reservations, payments, and asset performance, enhanced with Zapier automation for seamless workflows.",
        imgUrl: fleetfinesse,
        projectLink: "https://app.fleetfinesse.com/",
        // codeLink: "https://github.com/example/project-one",
        tags: ["Next.js", "SaaS"]
    },
    {
        title: "Demo Automation",
        description: " A SaaS-based platform that lets users upload demos, track analytics, share links, monitor traffic, and schedule demo bookings effortlessly.",
        imgUrl: demoautomation,
        projectLink: "https://demo-automation-adminpanel-woad.vercel.app/",
        // codeLink: "https://github.com/example/project-two",
        tags: ["React JS", "SaaS"]
    },
    {
        title: "Pak Car Bazaar",
        description: "A feature-rich platform for buying, selling, and comparing used cars, built with React, Next.js, and Node.js, featuring real-time chat, car inspections, and an optimized user experience.",
        imgUrl: pakcarbazar,
        projectLink: "https://example.com/project-four",
        codeLink: "https://github.com/example/project-four",
        tags: ["SaaS", "React JS"]
    },
    {
        title: "Real Time Colabration Tool",
        description: "A real-time collaboration tool for creating, editing, and sharing documents, enabling multiple users to collaborate seamlessly with a shareable access URL.",
        imgUrl: docs,
        // projectLink: "https://example.com/project-three",
        codeLink: "https://github.com/Ahmad-sheikh1/real-time-collaborative-document-editing-system",
        tags: ["React JS"]
    },
    {
        title: "Sharp Image Module",
        description: "A lightweight tool for resizing, enhancing quality, extracting text, and converting image formats efficiently.",
        imgUrl: images,
        // projectLink: "https://github.com/Ahmad-sheikh1/Sharp-Image-Module",
        codeLink: "https://github.com/Ahmad-sheikh1/Sharp-Image-Module",
        tags: ["React JS"]
    },
    {
        title: "Library Managment System",
        description: "A platform for managing books, allowing users to borrow, return, and track requests, while admins oversee approvals and book listings.",
        imgUrl: library,
        // projectLink: "https://example.com/project-six",
        codeLink: "https://github.com/Ahmad-sheikh1/Library-Management-System",
        tags: ["Angular"]
    }
];


export const SkillsData = [
    {
        name: "JavaScript",
        icon: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
        bgColor: "#edf2f8"
    },
    {
        name: "C++",
        icon: cpp,
        bgColor: "#edf2f8"
    },
    {
        name: "React",
        icon: "https://cdn-icons-png.flaticon.com/512/1126/1126012.png",
        bgColor: "#edf2f8"
    },
    {
        name: "Angular",
        icon: "https://cdn-icons-png.flaticon.com/512/226/226269.png",
        bgColor: "#edf2f8"
    },
    {
        name: "Node.js",
        icon: "https://cdn-icons-png.flaticon.com/512/919/919825.png",
        bgColor: "#edf2f8"
    },
    {
        name: "MongoDB",
        icon: mongopng,
        bgColor: "#edf2f8"
    },
    {
        name: "Docker",
        icon: docker,
        bgColor: "#edf2f8"
    },
    {
        name: "GitHub",
        icon: github,
        bgColor: "#edf2f8"
    },
    {
        name: "AWS",
        icon: aws,
        bgColor: "#edf2f8"
    },
];


export const ExperienceData = [
    {
        year: "Aug 2024 - Present",
        works: [
            {
                name: "MERN Stack Developer",
                company: "Fabtech Sol",
                desc: "Developed and maintained web applications using React, Node.js, and MongoDB. Improved API response times by 40%."
            }
        ]
    },
    {
        year: "April – Aug 2024",
        works: [
            {
                name: "MERN Stack Developer",
                company: "DevsRank",
                desc: "Built and deployed smart contracts on Ethereum and Solana. Worked on a decentralized betting platform with multi-chain support."
            }
        ]
    },
    {
        year: "Feb – April 2024",
        works: [
            {
                name: "MERN Stack Developer",
                company: "Gamica Cloud",
                desc: "Built and deployed smart contracts on Ethereum and Solana. Worked on a decentralized betting platform with multi-chain support."
            }
        ]
    }
];


